import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import LabelDocumentViewer from '@/components/mail/LabelDocumentViewer';

/**
 * A stored label in a dialog.
 *
 * Everything that matters — fetching, printing, downloading — lives in
 * LabelDocumentViewer, because the Mail page shows the same thing inline once a
 * label has been bought. Two copies of the blob handling would be two places to
 * fix the next time printing breaks.
 */
export default function PDFViewerDialog({
  open,
  onClose,
  documentUrl,
  title = 'Label',
  parcelIds = [],
  mailLabelIds = [],
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {/* Mounted only while open, so closing releases the blob. */}
        {open && (
          <LabelDocumentViewer
            documentUrl={documentUrl}
            title={title}
            parcelIds={parcelIds}
            mailLabelIds={mailLabelIds}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
